<template>
  <div style="height: 100%">
    <SplitContainer21 ref="refSplitContainer21" style="height:100%" :layout="12" :split_setting="0.7">
      <template #top>
        <TableMain name="one table" ref="QTHDistributionSearchTable1" :fields="fields1" :title="table_title.title1"
          :date_picker_label="''" :query_button_label="query_lable" :show_query_container="true"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false"
          :show_toolbar="true" :show_toolbar_state="true" :show_filter="true" :isBusy="isBusy" :table_height_adjust="-6"
          :show_close="true" :show_close_cancel="true" :show_toolbar_button="[0, 0, 1, 1, 0]"
          @current_changed="current_changed" @state_change="state_change" @on_query="on_query"
          :hb_table_class="'hb_table_qthdistributionsearch_class1'" tableref="474e2ee3b3bd414297e029a0de73661f">
          <template #query>
            <el-select placeholder="销售公司" size="small" v-model="dataAreaId" filterable clearable class="w-10">
              <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
                :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
            </el-select>
            <el-select placeholder="请输入报价申请编号关键词" class="ml-1 w-10" size="small" v-model="QuotationTaskNum" filterable
              remote reserve-keyword :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')"
              @focus="QTRemoteMethod('')">
              <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
            </el-select>
          </template>
          <template #toolbar>
            <div style="display: inline-block">
              <el-popover placement="right" title="提示" width="200" trigger="hover" content="默认显示100%完成分配，且未审批数据！"
                style="border-color: red;display: inline-block">
                <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
              </el-popover>
              <el-checkbox-group style="display: inline-block" class="ml-2" v-model="checkedConditions"
                @change="only_methods">
                <el-checkbox v-for="(item, index) in onlyCheckOptions" :label="item.value" :key="index">{{ item.label
                  }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="QTHDistributionSearchTable2" :fields="fields2" :show_query_container="false"
          :title="table_title.title2" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_toolbar="false" :show_toolbar_state="false" :check_state="false"
          :show_filter="false" :pager_count="5" :isBusy="isBusy2" @on_cell_button_click="on_cell_button_click"
          :hb_table_class="'hb_table_qthdistributionsearch_class2'" tableref="ccb363402de446ea9733a0a05990c62b">
        </TableMain>
      </template>
    </SplitContainer21>
    <!-- 供应商附件管理 -->
    <el-dialog title="供应商附件列表" :visible.sync="accessoryVendVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refVendAccessory" :accessoryCategory="'ConsultQuoteVend'" :showUpload="false"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as QuotationTaskHandleController from "../../controllers/sd/QuotationTaskHandleController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as localStorageMgr from "../../shared/localStorageMgr"
import BaseContainer from "../components/BaseContainer"
import SplitContainer21 from "../components/container/SplitContainer21"
import TableMain from "../components/table/TableMain"
import FileUpload from "../FileUpload.vue"

export default {
  components: {
    BaseContainer,
    SplitContainer21,
    TableMain,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "main_plan_view",
        title2: "quote_apply_distribut",
      },
      fields1: _.cloneDeep(QuotationTaskHandleController.fields.detail_distribution_search_default),
      fields2: _.cloneDeep(QuotationTaskHandleController.fields.detail_distribution_search_item),
      ItemId: "",
      isBusy: false,
      isBusy2: false,
      dataAreaId: "",
      QuotationTaskNum: "",
      QTOptions: [],
      all_role_users: [],
      DistributionHis: [],
      checkedConditions: [2],
      onlyCheckOptions: [
        { value: 1, label: "仅待审批" },
        { value: 2, label: "仅待我审批" },
        { value: 3, label: "仅已审批" }
      ],
      local_username: "",
      current_vend_accessory: null,///当前供应商选中附件
      accessoryVendVisible: false,
    }
  },
  async created() {
    await this.getAllRoleUsers()
  },
  watch: {
    "$route": {
      handler(val) {
        if (val) {
          if (val.query.k) {
            this.QuotationTaskNum = val.query.k
            this.on_query(this.$refs.QTHDistributionSearchTable1.SetData)
          }
        }
      },
      deep: true
      // immediate: true
    },
  },
  async mounted() {
    this.local_username = localStorageMgr.get(localStorageMgr.data.last_login_account)
    await this.on_query(this.$refs.QTHDistributionSearchTable1.SetData)
  },
  methods: {
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum }
        })
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvQuoteTask(query)
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        this.$refs.QTHDistributionSearchTable2.SetData([])
        set_data([])
      }
      let p = { quotationType: "大货报价" }
      if (this.dataAreaId != "") {
        p.dataAreaId = this.dataAreaId
      }
      if (this.QuotationTaskNum && this.QuotationTaskNum != "") {
        p.QuotationTaskNum = _.trim(this.QuotationTaskNum)
      }
      let _result = await QuotationTaskHandleController.methods.getDistributionSearchData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], { IsDistributedOk: true })
        for (var i in dt) {
          this.getApprover(dt[i])
        }
        this.DistributionHis = dt
        this.only_methods(this.checkedConditions)
      }
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSQODApprover",
        "SQODApprover",
        t.fcCheckSQODApproved
      )
    },
    only_methods(v) {
      let checkedValue = _.last(v)
      this.checkedConditions = [checkedValue]
      let dt = _.cloneDeep(this.DistributionHis)
      if (checkedValue == 1) ///未审批
      {
        dt = _.filter(dt, { fcCheckSQODApproved: false })
      }
      else if (checkedValue == 2) {///仅待我审批
        dt = _.filter(dt, (t) => {
          return t.SQODApprover && t.SQODApprover.indexOf(this.local_username) > -1
        })
      }
      else if (checkedValue == 3) { ///已审批
        dt = _.filter(dt, { fcCheckSQODApproved: true })
      }
      console.log(dt)
      let f = _.map(this.fields1, "key")
      f.push("fcCheckSQOrderApproved")
      f.push("QuotationTaskDetailId")
      f.push("isWeightedCostAllConfirm")

      dt = _.map(dt, (t) => {
        let m = _.cloneDeep(t)
        for (var key in m) {
          if (!_.includes(f, key) && key != 'qt_create_by' && key != 'qt_create_by_username') delete m[key]
        }
        return m
      })
      this.$refs.QTHDistributionSearchTable1.SetData(_.orderBy(_.uniqWith(dt, _.isEqual), ["QuotationTaskNum", "QuotationTaskLineNum"], ["desc", "asc"]))
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        //记录审批,反审 的action
        if (data.state == "approved" || data.state == "unapproved") {
          await QuotationTaskHandleController.methods.saveUserConfirmAction(`${data.state}_cancel`, data, this)
        }
        cb(false)
        return
      }
      if (data.state == "approved" || data.state == "unapproved") {
        await QuotationTaskHandleController.methods.saveUserConfirmAction(`${data.state}_confirm`, data, this)
      }

      let p = {}, msg = "", _select_list = _.cloneDeep(data.selected_items)
      let rt = null
      let confirm_m = null
      if (data.state == "approved" || data.state == "unapproved") {
        if (_.findIndex(data.selected_items, (t) => t.closed == 2) > -1) {
          this.msgToasts("报价已关闭，不能执行该操作！", "info")
          cb(false)
          return
        }
        let dtm = _.filter(data.selected_items, (t) => { return t.fcCheckSQODApproved == !(data.state == "approved") })
        let dt = []
        _.each(dtm, (t) => {
          if (data.state == "unapproved" && msg == "" && t.fcCheckSQOrderApproved) {
            msg = t.QuotationTaskNum + "报价单已经审批，不能执行该操作！"
          } else if (data.state == "unapproved" && msg == "" && t.isWeightedCostAllConfirm) {
            msg = "报价分配已确认，不能执行该操作！"
          } else {
            let items = _.filter(this.DistributionHis, {
              QuotationTaskNum: t.QuotationTaskNum,
              QuotationTaskLineNum: t.QuotationTaskLineNum,
              ItemId: t.ItemId
            })
            if (items && items.length > 0) dt = _.union(dt, items)
          }
        })
        if (msg != "") {
          this.msgToasts(msg, "info")
          cb(false)
          return
        }
        let not100dt = _.filter(dt, { IsDistributedOk: false })
        if (not100dt.length > 0) {
          let ask = await this.$confirm("选项中存在未100完成分配的数据，是否继续审批？").then(t => { return true }).catch(t => { return false })
          if (!ask) return
        }
        ///检查是否有该权限
        let check_ap_res = []
        let _check_ap_params = {
          list: dt.map((t) => { return { id: t.QuotationTaskDetailId } }),
          DocumentType: "SalesQuoteDistribution",
          approve_type: "",
          isNotCheckPrivilage: data.state == "approved" ? false : true,
          action_state: data.state == "approved",
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
        if (check_ap_res.notPriviligeIdList.length > 0 || check_ap_res.approveStatusIdList.length == 0) {
          this.msgToasts("抱歉，暂无审批权限！", "error")
          cb(false)
          return
        }

        p.approved = {}
        p.approved.data = dt
        p.approved.local_username = this.$global.global_data.local_username
        p.approved.approveStatusIdList = check_ap_res.approveStatusIdList
        console.log("🚀 ~ state_change ~  p.approved.approveStatusIdList:", p.approved.approveStatusIdList)
        p.approved.ApproveRemark = ""
        if (data.state == "approved") {
          p.approved.renewPreDistributionList = _.map(
            data.selected_items,
            (t) => {
              return {
                QuotationTaskNum: t.QuotationTaskNum, LineNum: t.QuotationTaskLineNum, IsDefaultApproved: 1,
                CreateUserId: t.create_by
              }
            }
          )
          p.approved.weightConfirmList = _.map(data.selected_items, (t) => { return t.QuotationTaskDetailId })
          let confirm_m = await this.$prompt('请输入审批意见', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\S\s]+$/,
            inputErrorMessage: '请输入审批意见',
            inputValue: "同意"
          }).then(({ value }) => {
            return { state: true, val: value }
          }).catch(() => {
            return { state: false }
          })
          if (confirm_m && confirm_m.state) { p.approved.ApproveRemark = confirm_m.val }
          else return
        }
        rt = await QuotationTaskHandleController.methods.saveDistributionData(p)
      }
      else if (data.state == "closed") {
        if (data.selected_items.length == 0) {
          this.msgToasts(this.$t("notify.not_data"), "info")
          return
        }
        if (_.findIndex(data.selected_items, (t) => t.closed == 1) > -1) {
          this.msgToasts("已发送关闭申请，请勿重复发送！", "info")
          return
        }
        if (_.findIndex(data.selected_items, (t) => t.SalesQuoteWeightCostApproved) > -1) {
          this.msgToasts("加权成本已审批不能执行该操作！", "info")
          return
        }
        confirm_m = await this.$prompt('请输入关闭原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入原因',
          inputValue: ""
        }).then(({ value }) => {
          return { state: true, val: value }
        }).catch(() => {
          return { state: false }
        })
        if (confirm_m && confirm_m.state) { }
        else return

        let dt = _.map(data.selected_items, (t) => {
          return {
            QuotationTaskDetailId: t.QuotationTaskDetailId,
            Description: confirm_m.val
          }
        })
        rt = await QuotationTaskController.methods.addQuoteCloseApplication(dt)
      }
      else if (data.state == "cancel_closed") { ///撤销关闭
        let wait_close_data = _.filter(data.selected_items, (t) => t.closed == 1)
        if (wait_close_data.length == 0) {
          this.msgToasts("暂无待关闭数据！", "info")
          return
        }
        //检查是否已经关闭
        let closed_data = await QuotationTaskController.methods.getDetailData(_.map(data.selected_items, (t) => { return { id: { "=": t.QuotationTaskDetailId }, closed: { "=": 2 } } }))
        if (!_.isNull(closed_data) && closed_data && closed_data.length > 0 && closed_data[0].length > 0) {
          this.msgToasts("报价已被销售关闭，请重新查询再执行该操作！", "info")
          return
        }
        rt = await QuotationTaskController.methods.cancelQuoteCloseApplication(_.map(data.selected_items, (t) => { return { QuotationTaskDetailId: t.QuotationTaskDetailId } }))
      }

      if (rt) {
        if (data.state == "approved")
          await this.SendEmail(_select_list)
        else if (data.state == "closed") {
          //关闭时给报价申请发送关闭申请邮件
          let _dt = _.map(_.cloneDeep(data.selected_items), (t) => {
            t.CloseDescription = confirm_m.val
            t.CloseUserName = this.$global.global_data.local_username
            t.CloseDate = this.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss")
            switch (t.IsHomemade) {
              case 0: t.IsHomemade = '否'; break
              case 1: t.IsHomemade = '是'; break
              case 2: t.IsHomemade = '纯外协'; break
            }
            return t
          })
          let email_data = _.groupBy(_dt, "qt_create_by_username")
          await commonController.handleEmailData(email_data, "quote_order_closed", this)
        }
        await this.on_query(this.$refs.QTHDistributionSearchTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },

    current_changed(old, current) {
      if (current) {
        let dt = _.filter(this.DistributionHis, {
          QuotationTaskNum: current.QuotationTaskNum,
          QuotationTaskLineNum: current.QuotationTaskLineNum,
          ItemId: current.ItemId
        })
        _.each(dt, (t) => {
          t.AccessoryVendCount = 0
          if (t.VendAccessory && t.VendAccessory != "")
            t.AccessoryVendCount = JSON.parse(t.VendAccessory).length
        })
        this.$refs.QTHDistributionSearchTable2.SetData(_.orderBy(dt, ["id"], ["asc"]))
      }
    },

    ///发送邮件
    async SendEmail(data) {
      console.log(data)
      let p = _.uniq(_.map(data, (t) => { return { QuotationTaskNum: t.QuotationTaskNum } }), _.isEqual)
      await commonController.handleEmailNotify(p, "quote_distribution_approved", this, this.all_role_users, "get_quotation_task_distribution")
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion
    //#region 供应商附件
    on_cell_button_click(data) {
      if (data.field.key == "VendAccessory") {
        this.current_vend_accessory = data.item
        this.accessoryVendVisible = true
      }
    },
    bottomDialogOpened() {
      this.$refs.refVendAccessory.getAccessory(this.current_vend_accessory.VendAccessory, this.current_vend_accessory.ItemId)
    },
    bottomSetAccessory(data) {
      this.current_vend_accessory.Accessory = data
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_qthdistributionsearch_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}

.hb_table_qthdistributionsearch_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 65rem;
}
</style>
